module.exports = __webpack_public_path__ + "img/pa.8bdc885c.svg";